import { withSnackbar, WithSnackbarProps } from 'notistack';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { store } from '../config/Store';
import { getLatestNotification } from '../selectors/snackbarNotifierSelectors';

const SnackbarNotifier: React.FC<WithSnackbarProps> = ({ enqueueSnackbar }) => {
  const notification = useSelector(getLatestNotification);

  useEffect(() => {
    // Reset the snackbar almost immediately after we render so the
    // user can see the notification. Then reset it. As the snackbar
    // disappears after a few seconds.
    //
    // If we reset immediately, then we won't show the snackbar at all.
    //
    // Because we only maintain one notification at a time, this does
    // mean that a snackbar sent through our rematch model could get
    // lost without being rendered if it shows up within this interval.
    if (notification.message !== null) {
      setTimeout(store.dispatch.snackbarNotifier.reset, 250);
    }
  });

  if (notification.message !== null) {
    enqueueSnackbar(notification.message, { variant: notification.variant });
  }

  // We don't actually render anything,
  // but we need a component to send
  // a Snackbar to the provider.
  return null;
};

export default withSnackbar(SnackbarNotifier);
